import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { MathNode, NODE_TYPE } from './math';
import { UntypedFormArray, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { getEditTypes } from '../../../delegatorUtils';
import { swalMini } from '../../../../../../../shared/utils/utils';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

@Component({
    selector: 'app-math',
    templateUrl: './math.component.html',
    styleUrls: ['./math.component.scss'],
    imports: [ReactiveFormsModule, ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ClickatellFormValidationComponent, ActiveFormDirective, CMSComponent, NextSelectorComponent]
})
export class MathComponent extends NodeBuilder implements OnInit {

  mathForm: UntypedFormGroup;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {

  }

  set buildForm(stepData: any) {
    this.mathForm = MathNode.toForm(stepData, this.canEdit);

    if (this.mathForm.get('yes').value === newStepValue) {
      this.mathForm.get('yes').setValue('step' + this.getNextStep());
    }
    if (this.mathForm.get('no').value === newStepValue) {
      this.mathForm.get('no').setValue('step' + this.getNextStep());
    }
    if (this.mathForm.get('error').value === newStepValue) {
      this.mathForm.get('error').setValue('step' + this.getNextStep());
    }
  }

  get getStepData(): {} {
    const nodeData = new MathNode();
    nodeData.addMathData(this.mathForm.getRawValue());
    return nodeData.nodeData;
  }

  get isNodeValid(): boolean {
    this.mathForm.markAllAsTouched();
    return this.mathForm.valid;
  }

  addVariable() {
    const { editFlows } = getEditTypes(this.canEdit);
    const vars = this.mathForm.get('variables') as UntypedFormArray;
    vars.push(MathNode.variableTemple('', '', editFlows));
  }

  deleteVariable(index: number) {
    const vars = this.mathForm.get('variables') as UntypedFormArray;
    if (vars.length > 1) {
      vars.removeAt(index);
    } else {
      swalMini({ title: 'At least one option needed', type: 'error' });
    }

  }

}
